import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '@/components/layout/PageContainer';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { H1, H3, P, Small } from '@/components/ui/typography';

interface SentryErrorFallbackProps {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError: () => void;
}

export const ErrorFallback: React.FC<SentryErrorFallbackProps> = ({
  resetError,
}) => {
  const { t } = useTranslation();

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <PageContainer>
      <div className='flex items-center justify-center min-h-[60vh]'>
        <Card glassmorphism className='w-full max-w-lg mx-auto text-center'>
          <CardHeader>
            <div className='flex flex-col items-center space-y-4'>
              <div className='text-6xl'>🚨</div>
              <H1 className='text-6xl font-bold text-red-600'>Error</H1>
            </div>
          </CardHeader>

          <CardContent className='space-y-6'>
            <H3 className='text-gray-900'>{t('errorPage.500.title')}</H3>

            <P className='text-gray-600 text-base'>
              {t('errorPage.500.description')}
            </P>

            <Small className='text-gray-500'>
              {t('errorPage.common.errorReported')}
            </Small>

            <div className='flex flex-col sm:flex-row gap-3 pt-2'>
              <Button
                onClick={resetError}
                className='flex-1 bg-red-600 hover:bg-red-700'
              >
                {t('errorPage.common.tryAgain')}
              </Button>
              <Button
                onClick={handleGoHome}
                variant='outline'
                className='flex-1'
              >
                {t('errorPage.common.goHome')}
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </PageContainer>
  );
};
